import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccountIdLoggedInCanActivate } from '../../guards';
import { AppInsufficientPermissionRouteParams } from '../../core/routeparams';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-insufficient-permission',
  templateUrl: './app-insufficient-permission.component.html',
  styleUrls: ['./app-insufficient-permission.component.scss'],
  standalone: false,
})
export class AppInsufficientPermissionComponent implements OnInit {
  accountGroupId: string;
  signinLink: string;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
  ) {}

  ngOnInit(): void {
    this.accountGroupId = (this.route.snapshot.params as AppInsufficientPermissionRouteParams).accountGroupId;

    if (this.accountGroupId) {
      this.signinLink = AccountIdLoggedInCanActivate.buildLoginUrl(
        this.accountGroupId,
        `/entry/${this.accountGroupId}`,
      );
    }
  }
}
